<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>

    <div class="container-fluid mt-6" v-if="isLoading == false">
      <div class="col-12 text-right">
        <base-button
          v-if="isRevisor"
          size="sm"
          type="primary"
          @click="toggleEditMode"
          class="ml-2"
        >
          {{ editMode ? "Cancelar edición" : "Editar equipo" }}
        </base-button>
        <base-button
          v-if="isRevisor && editMode"
          size="sm"
          type="success"
          @click="saveChanges"
          class="ml-2"
        >
          Guardar cambios
        </base-button>
        <base-button
          v-if="!editMode && isRevisor"
          size="sm"
          type="primary"
          @click="openRevisionModal(false)"
          class="ml-2"
        >
          <i class="fas fa-check-circle mr-1"></i>
          Revisar
        </base-button>
        <base-button
          v-if="!editMode && isRevisor"
          size="sm"
          type="primary"
          @click="openRevisionModal(true)"
          class="ml-2"
        >
          <i class="fas fa-bolt mr-1"></i>
          Revisión Rápida
        </base-button>
        <base-button
          v-if="!editMode && !isRevisor"
          size="sm"
          type="neutral"
          @click="revision()"
          class="ml-2"
        >
          Solicitar revisión
        </base-button>
        <base-button
          v-if="!editMode"
          size="sm"
          type="warning"
          @click="openIncidenceModal"
          class="ml-2"
        >
          <i class="fas fa-exclamation-triangle mr-1"></i>
          Reportar Incidencia
        </base-button>
        <base-button
          @click="goBack"
          type="button"
          class="btn btn-sm btn-primary ml-2"
          >Volver</base-button
        >
      </div>

      <div class="row align-items-center">
        <div class="col-xl-12">
          <!-- CARD DATOS BÁSICOS -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Datos básicos
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-3">
                  <img
                    v-if="asset.modelo && asset.modelo.imagen"
                    :src="asset.modelo.imagen.url"
                    style="width: 100%"
                  />
                  <img
                    v-else
                    src="https://misepis-name-images.s3.eu-west-1.amazonaws.com/logo_home_d5aa3a5d49.png"
                    style="width: 100%"
                  />
                </div>

                <div class="col-lg-7">
                  <div style="margin-bottom: 20px">
                    <span
                      class="badge badge-lg"
                      style="
                        color: white;
                        background-color: gray;
                        margin-right: 4px;
                      "
                      variant="success"
                      v-if="asset.retirado"
                      >EQUIPO RETIRADO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="
                        color: white;
                        background-color: black;
                        margin-right: 4px;
                      "
                      v-if="asset.fin_vida_util_alcanzada"
                      >Fin vida útil</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-if="incidenciasActivas.length > 0"
                      >EQUIPO CON INCIDENCIA</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'no_apto'
                      "
                      >NO APTO PARA SU USO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: green"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 60
                      "
                      >APTO PARA SU USO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: green"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto_a_vigilar' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 60
                      "
                      >APTO A VIGILAR</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: orange"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >APTO CADUCA PRONTO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: orange"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto_a_vigilar' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >APTO A VIGILAR CADUCA PRONTO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: blue"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length === 0 &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >PRÓXIMA REVISIÓN
                      {{ moment(asset.fecha_prox_revision).fromNow() }}</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-else
                      >REVISIÓN CADUCADA
                      {{ moment(asset.fecha_prox_revision).fromNow() }}</span
                    >
                  </div>
                  
                  <!-- NOMBRE DEL EQUIPO -->
                  <div class="row align-items-center" style="margin-top: 20px" v-if="asset.nombre || editMode">
                    <div class="col">
                      <span>Nombre del equipo</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.nombre || 'Sin nombre asignado' }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.nombre"
                        placeholder="Nombre del equipo"
                      />
                    </div>
                  </div>
                  
                  <div class="row align-items-center">
                    <div class="col">
                      <span>Subtipo</span>
                      <h3 class="mb-0" v-if="asset.modelo && asset.modelo.subtipo">
                        {{ asset.modelo.subtipo.nombre }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Modelo</span>
                      <h3 class="mb-0" v-if="asset.modelo">
                        {{ asset.modelo.nombre }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Fabricante</span>
                      <h3 class="mb-0" v-if="asset.modelo && asset.modelo.fabricante">
                        {{ asset.modelo.fabricante.nombre }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Número de QR</span>
                      <h3
                        class="mb-0"
                        v-if="!editMode && asset.numero_serie_qr"
                      >
                        {{ asset.numero_serie_qr }}
                      </h3>
                      <base-input
                        v-else-if="editMode"
                        v-model="editedAsset.numero_serie_qr"
                        placeholder="Número de QR"
                      />
                      <h3 class="mb-0" v-else>No tiene QR asignado</h3>
                    </div>
                    <div class="col">
                      <span>Número de serie</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.numero_serie }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.numero_serie"
                        placeholder="Número de serie"
                      />
                    </div>
                    <div class="col">
                      <span>Normativa</span>
                      <h3 class="mb-0" v-if="asset.modelo && asset.modelo.normativa">
                        {{ asset.modelo.normativa.nombre }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Fecha fabricación</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{
                          moment(asset.fecha_fabricacion).format("DD/MM/YYYY")
                        }}
                        ({{ moment(asset.fecha_fabricacion).fromNow() }})
                      </h3>
                      <div v-else>
                        <small class="text-muted d-block">
                          Fecha actual:
                          {{
                            moment(asset.fecha_fabricacion).format("DD/MM/YYYY")
                          }}
                        </small>
                        <base-input
                          type="date"
                          v-model="editedAsset.fecha_fabricacion"
                          :placeholder="
                            moment(asset.fecha_fabricacion).format('YYYY-MM-DD')
                          "
                        />
                      </div>
                    </div>
                    <div class="col">
                      <span>Fecha de Puesta en Servicio</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{
                          moment(asset.fecha_adquisicion).format("DD/MM/YYYY")
                        }}
                        ({{ moment(asset.fecha_adquisicion).fromNow() }})
                      </h3>
                      <div v-else>
                        <small class="text-muted d-block">
                          Fecha actual:
                          {{
                            moment(asset.fecha_adquisicion).format("DD/MM/YYYY")
                          }}
                        </small>
                        <base-input
                          type="date"
                          v-model="editedAsset.fecha_adquisicion"
                          :placeholder="
                            moment(asset.fecha_adquisicion).format('YYYY-MM-DD')
                          "
                        />
                      </div>
                    </div>
                    <div class="col">
                      <span>Fecha fin vida útil</span>
                      <h3 class="mb-0">
                        <template v-if="asset.fecha_fin_vida_util">
                          {{
                            moment(asset.fecha_fin_vida_util).format("DD/MM/YYYY")
                          }}
                          ({{ moment(asset.fecha_fin_vida_util).fromNow() }})
                        </template>
                        <template v-else>—</template>
                      </h3>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="asset.descripcion != null && asset.descripcion != ''"
                  >
                    <div class="col">
                      <span>Comentarios</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.descripcion }}
                      </h3>
                      <base-input
                        v-else
                        type="textarea"
                        rows="3"
                        v-model="editedAsset.descripcion"
                        placeholder="Añadir comentarios"
                      />
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      asset.revisiones.length > 0 &&
                      asset.revisiones[asset.revisiones.length - 1]
                        .observaciones != null &&
                      asset.revisiones[asset.revisiones.length - 1]
                        .observaciones != ''
                    "
                  >
                    <div class="col">
                      <span>Observaciones revisión</span>
                      <h3 class="mb-0">
                        {{
                          asset.revisiones[asset.revisiones.length - 1]
                            .observaciones
                        }}
                      </h3>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      (asset.ubicacion != null && asset.ubicacion != '') ||
                      editMode
                    "
                  >
                    <div class="col">
                      <span>Ubicación</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.ubicacion }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.ubicacion"
                        placeholder="Ubicación del equipo"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-lg-2" v-if="asset.numero_serie_qr && asset.numero_serie_qr !== 'null'">
                  <div class="text-center">
                    <qrcode-vue
                      :value="`https://admin.misepis.com/code/${asset.numero_serie_qr}`"
                      :size="150"
                      level="H"
                      class="qr-code mb-2"
                    />
                    <p class="mb-0 text-sm">{{ asset.numero_serie_qr }}</p>
                  </div>
                </div>
              </div>
            </div>
          </card>

          <!-- CARD INSPECCIONES VISUALES -->
          <card v-if="isSalvadorSeguridad">
            <div class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary" @click="toggleInspecciones" style="cursor:pointer;">
              Inspecciones visuales
              <small class="d-block" :class="{'text-warning': isPendingInspection}">
                {{ isPendingInspection ? 'Inspección mensual pendiente' : 'Historial de inspecciones visuales realizadas' }}
              </small>
              <i :class="isExpandedInspecciones ? 'fa fa-chevron-up float-right' : 'fa fa-chevron-down float-right'"></i>
            </div>
            <div class="card-body pt-0" v-show="isExpandedInspecciones">
              <div v-if="inspeccionesVisualesSorted.length === 0" class="text-center text-muted py-4">
                No hay inspecciones visuales registradas para este equipo.
              </div>
              <div v-else>
                <div
                  v-for="(insp, idx) in inspeccionesVisualesSorted"
                  :key="insp.id"
                  class="inspeccion-visual-block mb-4"
                  style="background: white; border-radius: 16px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); overflow: hidden;"
                >
                  <!-- Fecha/hora y Estado en la misma fila -->
                  <div class="subcard p-4 pb-3">
                    <div class="d-flex justify-content-between align-items-start">
                      <!-- Fecha y hora -->
                      <div class="flex-grow-1">
                        <h6 class="mb-3" style="color: #32325d; font-weight: 600;">Fecha y hora</h6>
                        <div class="d-flex align-items-center">
                          <i class="fa fa-clock mr-2" style="color: #7f1058;"></i>
                          <div style="color: #666; font-size: 1em;">
                            {{ formatFechaHora(insp.createdAt) }}
                            <div class="text-muted" style="font-size: 0.9em; margin-top: 2px;">{{ tiempoTranscurrido(insp.createdAt) }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Estado -->
                      <div class="ml-4">
                        <h6 class="mb-3" style="color: #32325d; font-weight: 600;">Estado</h6>
                        <div class="d-flex gap-2">
                          <span
                            class="badge d-flex align-items-center"
                            :style="{
                              background: '#2dce89',
                              color: '#fff',
                              fontWeight: '600',
                              fontSize: '0.9em',
                              borderRadius: '8px',
                              padding: '0.5em 1em',
                              marginRight: '8px'
                            }"
                          >
                            <i class="fa fa-check mr-1"></i>
                            COMPLETADA
                            <i v-if="insp.resolucion_tipo === 'resuelta'" class="fa fa-comment ml-2" title="Observaciones resueltas"></i>
                          </span>
                          <span
                            v-if="insp.resultado === 'con_incidencia'"
                            class="badge d-flex align-items-center"
                            :style="{
                              background: '#f5365c',
                              color: '#fff',
                              fontWeight: '600',
                              fontSize: '0.9em',
                              borderRadius: '8px',
                              padding: '0.5em 1em'
                            }"
                          >
                            <i class="fa fa-exclamation-circle mr-1"></i>
                            OBSERVACIONES
                            <i v-if="insp.resolucion_tipo === 'resuelta'" class="fa fa-comment ml-2" title="Observaciones resueltas"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Checklist Results -->
                  <div class="subcard p-4 pb-3" v-if="insp.checklist_results && insp.checklist_results.length > 0">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 style="color: #32325d; font-weight: 600;">Checklist de inspección</h6>
                      <base-button
                        type="primary"
                        size="sm"
                        @click="toggleChecklist(insp.id)"
                        class="btn-icon"
                      >
                        <span class="btn-inner--icon">
                          <i :class="isChecklistVisible(insp.id) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </span>
                        <span class="btn-inner--text ml-1">
                          {{ isChecklistVisible(insp.id) ? 'Ocultar checklist' : 'Ver checklist' }}
                        </span>
                      </base-button>
                    </div>
                    
                    <div v-show="isChecklistVisible(insp.id)" class="checklist-container">
                      <div 
                        v-for="item in insp.checklist_results" 
                        :key="item.number"
                        class="checklist-item"
                        :class="{'border-bottom': true}"
                      >
                        <div class="d-flex justify-content-between align-items-start py-3">
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center">
                              <span class="question-number mr-2">{{ item.number }}.</span>
                              <span class="question-text">{{ item.question }}</span>
                            </div>
                          </div>
                          <div class="ml-3">
                            <span 
                              class="badge"
                              :style="{
                                color: '#fff',
                                fontWeight: '600',
                                fontSize: '0.9em',
                                padding: '0.5em 1em'
                              }"
                              :class="{
                                'badge-success': item.answer === 0,
                                'badge-warning': item.answer === 1,
                                'badge-danger': item.answer === 2,
                                'badge-info': item.answer === 3
                              }"
                            >
                              {{ getAnswerText(item.answer) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Comentarios -->
                  <div class="subcard p-4 pb-3" v-if="insp.comentario">
                    <h6 class="mb-3" style="color: #32325d; font-weight: 600;">Comentarios del usuario</h6>
                    <div class="d-flex align-items-start">
                      <i class="fa fa-comment-alt mt-1 mr-2" style="color: #7f1058;"></i>
                      <div style="color: #444; font-weight: 500;">{{ insp.comentario }}</div>
                    </div>
                  </div>

                  <!-- Comentario del revisor -->
                  <div class="subcard p-4 pb-3" v-if="insp.resolucion_comentario">
                    <h6 class="mb-3" style="color: #32325d; font-weight: 600;">Comentario del revisor</h6>
                    <div class="d-flex align-items-start">
                      <i class="fa fa-user-tie mt-1 mr-2" style="color: #2dce89;"></i>
                      <div style="color: #444; font-weight: 500;">{{ insp.resolucion_comentario }}</div>
                    </div>
                  </div>

                  <!-- Botón Resolver para inspecciones con incidencia -->
                  <div class="subcard p-4 pb-3" v-if="insp.resultado === 'con_incidencia' && insp.resolucion_tipo !== 'resuelta'">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="mb-0" style="color: #32325d; font-weight: 600;">Comentarios del revisor</h6>
                    </div>
                   <div class="form-group">
                     <textarea
                       v-model="resolucionComentarios[insp.id]"
                       class="form-control"
                       rows="3"
                       placeholder="Añade tu comentario como revisor sobre las observaciones encontradas..."
                     ></textarea>
                   </div>
                   <div class="text-right mt-3">
                     <base-button
                       type="success"
                       size="sm"
                       @click="resolveInspeccion(insp)"
                       :loading="resolving"
                       :disabled="!resolucionComentarios[insp.id] || !resolucionComentarios[insp.id].trim()"
                     >
                       <i class="fa fa-check mr-1"></i>
                       Guardar comentario
                     </base-button>
                   </div>
                  </div>

                  <!-- Imágenes -->
                  <div class="subcard p-4 pb-3" v-if="insp.foto && insp.foto.length">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="mb-0" style="color: #32325d; font-weight: 600;">Imágenes</h6>
                      <span class="text-muted small">
                        {{ insp.foto.length === 1 ? '1 imagen' : insp.foto.length + ' imágenes' }}
                      </span>
                    </div>
                    <div class="d-flex flex-wrap">
                      <div v-for="(img, i) in insp.foto" :key="i" class="position-relative mr-2 mb-2">
                        <img
                          :src="img.formats.small.url"
                          class="rounded"
                          alt="Imagen inspección visual"
                          style="width: 120px; height: 120px; object-fit: cover; border: 1px solid #eee; cursor: pointer;"
                          @click="openImage(img.formats.large.url)"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Usuario -->
                  <div class="subcard p-4 pb-3" style="border-bottom: none;">
                    <h6 class="mb-3" style="color: #32325d; font-weight: 600;">Realizada por</h6>
                    <div class="d-flex align-items-center" style="color: #666;">
                      <i class="fa fa-user-circle mr-2"></i>
                      <template v-if="insp.users_permissions_user && insp.users_permissions_user.id">
                        <router-link
                          :to="'/user-management/edit-user/' + insp.users_permissions_user.id"
                          class="font-weight-bold"
                          style="color: #7f1058; text-decoration: none;"
                        >
                          {{ insp.users_permissions_user.nombre + ' ' + insp.users_permissions_user.apellidos }}
                        </router-link>
                      </template>
                      <template v-else>
                        <span>{{ insp.usuario?.nombre || 'Desconocido' }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>

          <!-- CARD INCIDENCIA -->
          <card
            v-if="incidenciasActivas.length > 0"
            class="border border-danger"
          >
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Incidencia
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-12">
                  <!-- PRIMERA FILA -->
                  <div class="row align-items-center">
                    <!--PRIORIDAD -->
                    <div class="col">
                      <span>Prioridad</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            incidenciasActivas[0].prioridad == 'Alta'
                              ? { backgroundColor: 'red' }
                              : { backgroundColor: 'orange' },
                          ]"
                          >{{ incidenciasActivas[0].prioridad }}</span
                        >
                      </h3>
                    </div>
                    <!-- ESTADO -->
                    <div class="col">
                      <span>Estado</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            incidenciasActivas[0] && incidenciasActivas[0].estado_incidencia
                              ? incidenciasActivas[0].estado_incidencia.nombre == 'Abierta'
                                ? { backgroundColor: 'info' }
                                : { backgroundColor: 'green' }
                              : { backgroundColor: 'info' }
                          ]"
                          >{{
                            incidenciasActivas[0] && incidenciasActivas[0].estado_incidencia && incidenciasActivas[0].estado_incidencia.nombre == "Abierta"
                              ? "Incidencia Abierta"
                              : "Incidencia Cerrada"
                          }}</span
                        >
                      </h3>
                    </div>
                    <!-- TIPO -->
                    <div class="col">
                      <span>Tipo</span>
                      <h3 class="mb-0" style="text-transform: uppercase">
                        {{ incidenciasActivas[0] && incidenciasActivas[0].tipo_incidencia ? incidenciasActivas[0].tipo_incidencia.descripcion : '' }}
                      </h3>
                    </div>
                  </div>
                  <!-- SEGUNDA FILA -->
                  <div class="row align-items-center" style="margin-top: 20px">
                    <!-- USUARIO -->
                    <div class="col">
                      <span>Creada por</span>

                      <h3 class="mb-0">
                        <!-- Avatar -->
                        <!--  <img
                          v-if="
                            asset.incidencias[0] &&
                            asset.incidencias[0]..usuario
                              ..imagen_perfil.url
                          "
                          :src="
                            asset.incidencias[0]..usuario
                              ..imagen_perfil.url
                          "
                          class="avatar rounded-circle"
                        />
                        <img
                          v-else
                          src="/img/placeholder.png"
                          class="avatar rounded-circle"
                        /> -->
                        <a
                          :href="
                            '/user-management/edit-user/' +
                            (incidenciasActivas[0] && incidenciasActivas[0].usuario ? incidenciasActivas[0].usuario.id : '')
                          "
                          class="font-weight-bold"
                        >
                          <b>
                            {{
                              (incidenciasActivas[0] && incidenciasActivas[0].usuario ? incidenciasActivas[0].usuario.nombre : '') +
                              " " +
                              (incidenciasActivas[0] && incidenciasActivas[0].usuario ? incidenciasActivas[0].usuario.apellidos : '')
                            }}</b
                          ></a
                        >
                      </h3>
                    </div>
                    <!-- FECHA -->
                    <div class="col">
                      <span>Fecha de creación</span>
                      <h3 class="mb-0">
                        {{
                          moment(incidenciasActivas[0].createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                        ({{ moment(incidenciasActivas[0].createdAt).fromNow() }})
                      </h3>
                    </div>
                    <!-- MOTIVO -->
                    <div class="col">
                      <span>Motivo de la incidencia</span>
                      <h3 class="mb-0">
                        {{
                          incidenciasActivas[0].descripcion === ""
                            ? "El usuario no ha escrito el motivo"
                            : incidenciasActivas[0].descripcion
                        }}
                      </h3>
                    </div>
                  </div>
                  <!-- TERCERA FILA -->
                  <div class="row" style="margin-top: 20px">
                    <!-- IMÁGENES DE LA INCIDENCIA -->
                    <div
                      class="col"
                      v-if="
                        this.incidenciasActivas[0].incidence_documents != null
                      "
                    >
                      <span>Imágenes de la incidencia</span>
                      <div class="mb-0">
                        <img
                          v-for="image in this.incidenciasActivas[0]
                            .incidence_documents"
                          :src="image.url"
                          v-bind:key="image.id"
                          style="
                            width: auto;
                            max-height: 200px;
                            margin-inline-end: 20px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- CUARTA FILA -->
                  <div class="row align-items-center" style="margin-top: 20px">
                    <!-- DESCARGAR -->
                    <div class="col">
                      <span>Documentación</span>
                      <h3 class="mb-0">
                        <button
                          type="button"
                          class="btn-icon-clipboard"
                          style="width: auto"
                          @click="downloadFileUrl(incidenciasActivas[0].pdf)"
                        >
                          <div>
                            <span class="btn-inner--icon"
                              ><i class="fas fa-download"></i
                            ></span>
                            <span style="font-size: medium; font-weight: 500"
                              >Descargar PDF de la incidencia</span
                            >
                          </div>
                        </button>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              :to="
                '/incidencia-management/view-incidencia/' +
                incidenciasActivas[0].id
              "
              class="dropdown-item text-center text-primary font-weight-bold py-3"
              >Ver incidencia</router-link
            >
          </card>
          
          <!-- HISTORIAL DE INCIDENCIAS -->
          <card
            v-if="historialIncidencias.length > 0"
            class="border border-info"
          >
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              <i class="fas fa-history mr-2"></i>
              Historial de Incidencias
            </div>
            <div class="card-body pt-0">
              <div class="table-responsive">
                <table class="table table-hover align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" style="width: 10%">Fecha</th>
                      <th scope="col" style="width: 15%">Estado</th>
                      <th scope="col" style="width: 15%">Prioridad</th>
                      <th scope="col" style="width: 20%">Tipo</th>
                      <th scope="col" style="width: 30%">Descripción</th>
                      <th scope="col" style="width: 10%">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="incidencia in historialIncidencias"
                      :key="incidencia.id || incidencia.data?.id || `incidencia-${historialIncidencias.indexOf(incidencia)}`"
                      style="background-color: white;"
                    >
                      <td>
                        <small class="text-muted">
                          {{ moment(getIncidenciaField(incidencia, 'createdAt') || incidencia.createdAt).format("DD/MM/YYYY") }}
                          <br>
                          <span class="text-muted">{{ moment(getIncidenciaField(incidencia, 'createdAt') || incidencia.createdAt).format("HH:mm") }}</span>
                        </small>
                      </td>
                      <td>
                        <span
                          class="badge badge-default"
                          :style="[
                            getEstadoIncidencia(incidencia) === 'Abierta'
                              ? { backgroundColor: '#17a2b8', color: 'white' }
                              : getEstadoIncidencia(incidencia) === 'Resuelta'
                              ? { backgroundColor: '#28a745', color: 'white' }
                              : { backgroundColor: '#6c757d', color: 'white' }
                          ]"
                        >
                          {{ getEstadoIncidencia(incidencia) }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge badge-default"
                          :style="[
                            (getIncidenciaField(incidencia, 'prioridad') === 'Alta' || getIncidenciaField(incidencia, 'prioridad') === 'alta')
                              ? { backgroundColor: '#dc3545', color: 'white' }
                              : { backgroundColor: '#fd7e14', color: 'white' }
                          ]"
                        >
                          {{ getIncidenciaField(incidencia, 'prioridad') || 'N/A' }}
                        </span>
                      </td>
                      <td>
                        <small class="text-muted" style="text-transform: uppercase">
                          {{ incidencia.tipo_incidencia?.descripcion || 
                             incidencia.tipo_incidencia?.data?.attributes?.descripcion || 
                             'N/A' }}
                        </small>
                      </td>
                      <td>
                        <div class="text-truncate" style="max-width: 300px;" :title="getIncidenciaField(incidencia, 'descripcion') || 'Sin descripción'">
                          {{ getIncidenciaField(incidencia, 'descripcion') || 'Sin descripción' }}
                        </div>
                        <div v-if="getIncidenciaField(incidencia, 'resolucion') && getIncidenciaField(incidencia, 'resolucion').trim()" class="mt-2">
                          <small class="text-success">
                            <i class="fas fa-check-circle mr-1"></i>
                            <strong>Resolución:</strong> {{ getIncidenciaField(incidencia, 'resolucion') }}
                          </small>
                        </div>
                      </td>
                      <td>
                        <router-link
                          :to="'/incidencia-management/view-incidencia/' + (incidencia.id || incidencia.data?.id)"
                          class="btn btn-sm btn-primary"
                        >
                          <i class="fas fa-eye mr-1"></i>
                          Ver
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="historialIncidencias.length === 0" class="text-center py-4">
                <p class="text-muted">No hay incidencias registradas para este activo.</p>
              </div>
            </div>
          </card>
          
          <!-- USUARIO -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Usuario asignado
            </div>
            <div class="card-body pt-0">
              <div
                class="row align-items-center col-lg-12"
                v-if="asset.usuario !== null"
              >
                <!-- Avatar -->
                <img
                  v-if="
                    asset.usuario &&
                    asset.usuario.imagen_perfil != null &&
                    asset.usuario.imagen_perfil.url
                  "
                  :src="asset.usuario.imagen_perfil.url"
                  class="avatar rounded-circle"
                />
                <img
                  v-else
                  src="/img/placeholder.png"
                  class="avatar rounded-circle"
                />
                <!-- <img
                        alt="Image placeholder"
                        src="https://demos.creative-tim.com/argon-dashboard-pro-bs4/assets/img/theme/team-4.jpg"
                      /> -->

                <div class="col-lg-3">
                  <span>Nombre y Apellidos</span>

                  <h3 class="mb-0">
                    <a
                      :href="'/user-management/edit-user/' + (asset.usuario ? asset.usuario.id : '')"
                      class="font-weight-bold"
                    >
                      <b>
                        {{
                          (asset.usuario && asset.usuario.nombre ? asset.usuario.nombre : '') +
                          " " +
                          (asset.usuario && asset.usuario.apellidos ? asset.usuario.apellidos : '')
                        }}</b
                      ></a
                    >
                  </h3>
                </div>
                <div class="col-lg-3">
                  <span>Correo electrónico</span>
                  <h3 class="mb-0">
                    {{ asset.usuario && asset.usuario.email ? asset.usuario.email : '' }}
                  </h3>
                </div>
                <div class="col-lg-2">
                  <span>Rol</span>
                  <h3 class="mb-0">
                    {{ asset.usuario && asset.usuario.role ? asset.usuario.role.name : '' }}
                  </h3>
                </div>
                <div class="col-lg-3">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    style="width: auto"
                    @click="desAssignPost()"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-user-minus"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Devolver equipo</span
                      >
                    </div>
                  </button>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>
                    Este equipo no está asignado a ningún usuario y se encuentra
                    disponible.
                  </h4>
                </div>
                <div class="col-lg-6">
                  <div class="col">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="assign()"
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-user-plus"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >Asignar este equipo a un usuario</span
                        >
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="asset.usuario !== null">
              <router-link
                :to="'/user-management/edit-user/' + (asset.usuario ? asset.usuario.id : '')"
                class="dropdown-item text-center text-primary font-weight-bold py-3"
                >Ver usuario</router-link
              >
            </div>
          </card>

          <!-- REVISIÓN -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Certificado de revisión
            </div>
            <div class="card-body pt-0">
              <!--  TENGO REVISIONES HECHAS CON Misepis -->
              <div class="row col-lg-12 align-items-center">
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    style="width: fit-content"
                    @click="downloadFile()"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Certificado de revisión</span
                      >
                    </div>
                  </button>
                </div>
                <div class="col">
                  <span>Fecha última revisión</span>
                  <h3 class="mb-0">
                    {{
                      moment(asset.fecha_prox_revision)
                        .subtract(1, "years")
                        .format("DD/MM/YYYY")
                    }}
                  </h3>
                </div>
                <div class="col">
                  <span>Fecha próxima revisión</span>
                  <h3 class="mb-0">
                    {{ moment(asset.fecha_prox_revision).format("DD/MM/YYYY") }}
                    ({{ moment(asset.fecha_prox_revision).fromNow() }})
                  </h3>
                </div>
              </div>
            </div>
          </card>

          <!-- CARD IMÁGENES -->
          <card v-if="asset.imagenes_adicionales?.length > 0 || editMode">
            <div class="h3 card-header border-0 text-primary">
              Galería de Imágenes
            </div>
            <div class="card-body">
              <div
                v-if="editMode"
                class="dropzone mb-3"
                :class="{ 'dropzone-active': isDragging }"
                @dragenter.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @dragover.prevent
                @drop.prevent="handleDrop"
              >
                <div class="dropzone-content">
                  <i class="fas fa-cloud-upload-alt fa-3x mb-2"></i>
                  <p>Arrastra y suelta imágenes aquí o</p>
                  <base-button
                    size="sm"
                    type="primary"
                    @click="$refs.imageInput.click()"
                  >
                    Selecciona archivos
                  </base-button>
                  <input
                    ref="imageInput"
                    type="file"
                    multiple
                    accept="image/*"
                    style="display: none"
                    @change="handleImageSelect"
                  />
                </div>
              </div>

              <div class="row">
                <div
                  v-for="(imagen, index) in displayedImages"
                  :key="imagen.id || index"
                  class="col-md-4 mb-3 position-relative"
                >
                  <img
                    :src="imagen.url || imagen.preview"
                    class="img-thumbnail"
                    alt="Imagen Adicional"
                    style="width: 100%; height: auto"
                  />
                  <button
                    v-if="editMode"
                    @click="removeAdditionalImage(index)"
                    class="btn btn-danger btn-sm position-absolute"
                    style="top: 10px; right: 25px"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </card>

          <!-- DOCUMENTACIÓN TÉCNICA -->
          <card>
            <div class="h3 card-header border-0 text-primary">
              Documentación técnica
            </div>
            <div class="card-body pt-0">
              <div class="row col-lg-12 align-items-center">
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFileUrl(asset.modelo.ficha_tecnica.url)"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Ficha técnica</span
                      >
                    </div>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="
                      downloadFileUrl(asset.modelo.declaracion_conformidad.url)
                    "
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Declaración de Conformidad</span
                      >
                    </div>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFileUrl(asset.modelo.manual_usuario.url)"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Manual de usuario</span
                      >
                    </div>
                  </button>
                </div>
                <div
                  class="col"
                  v-if="
                    asset.modelo.subtipo.nombre ===
                    'PUNTO DE ANCLAJE TRANSPORTABLE'
                  "
                >
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFileUrl(asset.certificado_instalacion.url)"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Certificado de instalación</span
                      >
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </card>

          <!--  DOCUMENTACIÓN ADICIONAL -->
          <card>
            <div class="h3 card-header border-0 text-primary">
              Documentación adicional
              <div v-if="isRevisor && editMode" class="float-right">
                <base-button
                  size="sm"
                  type="neutral"
                  @click="openDocumentUpload"
                >
                  <i class="fas fa-plus"></i> Añadir documento
                </base-button>
                <input
                  ref="documentInput"
                  type="file"
                  style="display: none"
                  @change="handleDocumentUpload"
                />
              </div>
            </div>
            <div class="card-body pt-0">
              <div
                class="row"
                v-if="asset.doc_adicional && asset.doc_adicional.length > 0"
              >
                <div class="col-lg-12">
                  <h4
                    v-for="documento in asset.doc_adicional"
                    v-bind:key="documento.id"
                  >
                    <div class="row">
                      <div class="col-lg-4">
                        <button
                          type="button"
                          class="btn-icon-clipboard"
                          @click="downloadAdditionalFile(documento)"
                        >
                          <div>
                            <span class="btn-inner--icon"
                              ><i class="fas fa-download"></i
                            ></span>
                            <span style="font-size: medium; font-weight: 500">{{
                              documento.nombre
                            }}</span>
                          </div>
                        </button>
                      </div>
                      <div v-if="isRevisor && editMode" class="col-lg-2">
                        <base-button
                          size="sm"
                          type="danger"
                          @click="removeDocument(documento)"
                        >
                          <i class="fas fa-trash"></i> Eliminar
                        </base-button>
                      </div>
                    </div>
                  </h4>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>No hay documentos adicionales.</h4>
                </div>
              </div>
            </div>
          </card>

          <!--  HISTORIAL REVISIONES -->
          <card v-if="this.asset.revisiones.length > 0">
            <div class="h3 card-header border-0 text-primary">
              Historial de revisiones
            </div>
            <div class="card-body pt-0">
              <div class="col-lg-12">
                <h4
                  v-for="revision in [...asset.revisiones].reverse()"
                  v-bind:key="revision.id"
                >
                  <div class="row">
                    <div class="col-lg-4">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="downloadFile(revision.id)"
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >{{
                              moment(revision.fecha_revision).format(
                                "DD/MM/YYYY"
                              )
                            }}

                            ({{ revision.estado_revision.nombre }})</span
                          >
                        </div>
                      </button>
                    </div>
                  </div>
                </h4>
              </div>
            </div>
          </card>

          <!-- HISTORIAL DE ALBARANES -->
          <card v-if="historialAlbaranes.length > 0 && asset.empresa && asset.empresa.id === 172">
            <div class="h3 card-header border-0 text-primary d-flex justify-content-between align-items-center" style="cursor: pointer;" @click="toggleHistorial">
              <span>Historial de Albaranes ({{ historialAlbaranes.length }})</span>
              <i class="fas" :class="historialExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
            <div v-show="historialExpanded" class="card-body pt-0">
              <div class="col-lg-12">
                <div v-for="albaran in historialAlbaranes" :key="albaran.id" class="mb-3">
                  <div class="card border-left-primary">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col-md-3">
                          <h6 class="mb-0">{{ albaran.attributes?.numero || albaran.numero }}</h6>
                          <small class="text-muted">{{ albaran.attributes?.titulo || albaran.titulo }}</small>
                        </div>
                        <div class="col-md-2">
                          <span 
                            class="badge badge-lg estado-badge-listado" 
                            :class="getEstadoBadgeClass(getEstadoAlbaranHistorial(albaran))"
                            :style="{
                              backgroundColor: getEstadoColorAlbaranHistorial(getEstadoAlbaranHistorial(albaran)),
                              color: '#fff'
                            }"
                          >
                            {{ formatEstado(getEstadoAlbaranHistorial(albaran)) || '—' }}
                          </span>
                        </div>
                        <div class="col-md-2">
                          <small class="text-muted">Fecha entrega</small>
                          <div>{{ formatDate(albaran.attributes?.fecha_entrega || albaran.fecha_entrega) }}</div>
                        </div>
                        <div class="col-md-2">
                          <small class="text-muted">Cliente</small>
                          <div>{{ albaran.attributes?.cliente || albaran.cliente || 'N/A' }}</div>
                        </div>
                        <div class="col-md-3 text-right">
                          <base-button
                            size="sm"
                            type="primary"
                            @click="verAlbaran(albaran.id)"
                          >
                            <i class="fas fa-eye mr-1"></i>
                            Ver Detalle
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <!-- DIALOG ASIGNACIÓN EQUIPOS -->
    <el-dialog
      title="Asignación de equipos"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <div class="col-auto">
        <p>Selecciona el usuario al que quieres asignar este equipo:</p>
        <el-select
          style="width: 100%"
          size="large"
          name="usuario"
          v-model="usuarioSeleccionado"
          placeholder="Selecciona el usuario..."
          filterable
        >
          <el-option
            v-for="usuario in available_usuarios"
            :key="usuario.id"
            :value="usuario.id"
            :label="`${usuario.nombre} ${usuario.apellidos}`"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisible = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button
          v-if="usuarioSeleccionado"
          @click="assignPost"
          type="primary"
          >Confirmar</base-button
        >
      </span>
    </el-dialog>
    <!-- DIALOG SOLICITUD REVISIÓN -->
    <el-dialog
      title="Solicitar revisión a Misepis"
      :visible.sync="dialogFormVisibleRev"
      width="60%"
    >
      <div class="col-auto">
        <p>
          Si aceptas se enviará una solicitud para realizar una revisión de este
          equipo.
        </p>
        <ul>
          <li>
            Identificador: <b>{{ this.asset.nombre }}</b
            >. Número de serie:
            <b>{{ this.asset.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRev = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="revisionPost" type="primary">Aceptar</base-button>
      </span>
    </el-dialog>

    <!-- Modal de Incidencia -->
    <el-dialog
      title="Reportar Incidencia del Activo"
      :visible.sync="showIncidenceModal"
      width="50%"
      :before-close="closeIncidenceModal"
    >
      <div class="modal-body">
        <div class="alert alert-warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>Activo:</strong> {{ asset.numero_serie }} - {{ asset.nombre }}
        </div>
        
        <div class="form-group">
          <label class="form-control-label">Tipo de Incidencia</label>
          <select 
            v-model="incidenceData.tipo" 
            class="form-control"
            required
          >
            <option value="">Seleccionar tipo de incidencia</option>
            <option value="dañado">Activo Dañado</option>
            <option value="perdido">Activo Perdido</option>
            <option value="defectuoso">Activo Defectuoso</option>
            <option value="incompleto">Activo Incompleto</option>
            <option value="otro">Otro</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-control-label">Descripción de la Incidencia</label>
          <textarea
            v-model="incidenceData.descripcion"
            class="form-control"
            rows="4"
            placeholder="Describe detalladamente la incidencia..."
            required
          ></textarea>
        </div>

        <div class="form-group">
          <label class="form-control-label">Acción Requerida</label>
          <select 
            v-model="incidenceData.accion" 
            class="form-control"
            required
          >
            <option value="">Seleccionar acción requerida</option>
            <option value="reparar">Reparar</option>
            <option value="reemplazar">Reemplazar</option>
            <option value="devolver">Devolver</option>
            <option value="investigar">Investigar</option>
            <option value="otro">Otro</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-control-label">Prioridad</label>
          <select 
            v-model="incidenceData.prioridad" 
            class="form-control"
            required
          >
            <option value="baja">Baja</option>
            <option value="media">Media</option>
            <option value="alta">Alta</option>
            <option value="critica">Crítica</option>
          </select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <base-button type="secondary" @click="closeIncidenceModal">
          Cancelar
        </base-button>
        <base-button
          type="warning"
          @click="submitIncidence"
          :loading="submittingIncidence"
          :disabled="!isValidIncidence"
        >
          <i class="fas fa-exclamation-triangle mr-2"></i>
          Reportar Incidencia
        </base-button>
      </span>
    </el-dialog>

    <!-- Modal de Revisión -->
    <revision-modal
      :activo="asset"
      :visible.sync="showRevisionModal"
      :is-semi-automatic="isSemiAutomaticRevision"
      @close="closeRevisionModal"
      @revision-created="onRevisionCreated"
    />
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import QrcodeVue from 'qrcode.vue';
import { getEstadoColor as getEstadoColorUtil, getEstadoBadgeClass as getEstadoBadgeClassUtil, getEstadoTexto as getEstadoTextoUtil } from "@/util/estadoColors";
import {
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  Button,
  Image,
  // Loading
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import formMixin from "@/mixins/form-mixin";
import moment from "moment";
import { cloneDeep } from "lodash";
import RevisionModal from "@/components/RevisionModal.vue";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

export default {
  layout: "DashboardLayout",
  components: {
    RevisionModal,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Image.name]: Image,
    QrcodeVue,
    RevisionModal
  },
  mixins: [formMixin],

  data() {
    return {
      image: "",
      file: null,
      available_empresas: [],
      available_divisiones: [],
      available_tipos: [],
      available_subtipos: [],
      available_fabricantes: [],
      available_modelos: [],
      images_incidence: [],
      isLoading: false,
      loadingColor: "#7f1058",
      loadingBgColor: "#000",
      loadingHeight: 128,
      loadingWidth: 128,
      dialogFormVisible: false,
      dialogFormVisibleRev: false,
      available_usuarios: [],
      usuarioSeleccionado: null,
      checklistVisibility: {},
      asset: {
        type: "assets",
        nombre: null,
        numero_serie: "",
        numero_serie_qr: "",
        division: {
          id: null,
        },
        tipo: {
          id: null,
        },
        subtipo: {
          id: null,
        },
        fabricante: {
          id: null,
        },
        modelo: {
          id: null,
          nombre: null,
          subtipo: null,
          fabricante: null,
          normativa: null,
          imagen: null
        },
        empresa: {
          id: null,
        },
        fecha_adquisicion: null,
        fecha_fabricacion: null,
        fecha_prox_revision: null,
        fecha_fin_vida_util: null,
        imagen: null,
        usuario: null,
        incidencias: [],
        revisiones: [],
        descripcion: "",
        ubicacion: "",
        retirado: false,
        fin_vida_util_alcanzada: false
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1, //pendiente de enviar
        },
        tipo_notificacion: {
          id: 3, //tipo: revision
        },
        usuario_origen: {
          id: null,
        },
        usuario_destino: {
          id: null,
        },
        empresa: {
          id: null,
        },
        activos: {},
      },
      isRevisor: false,
      editMode: false,
      editedAsset: null,
      isDragging: false,
      newImages: [],
      imagesToDelete: [],
      displayedImages: [],
      isExpandedInspecciones: false,
      resolving: false,
      resolucionComentarios: {}, // Nuevo objeto para almacenar los comentarios de resolución
      // Variables para gestión de incidencias
      showIncidenceModal: false,
      submittingIncidence: false,
      incidenceData: {
        tipo: '',
        descripcion: '',
        accion: '',
        prioridad: 'media'
      },
      // Variables para historial de albaranes
      historialAlbaranes: [],
      loadingHistorial: false,
      historialExpanded: false,
      // Variables para modal de revisión
      showRevisionModal: false,
      isSemiAutomaticRevision: false
    };
  },
  created() {
    this.checkUserRole();
    this.get();
    this.getUsers();
  },

  watch: {},
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },

    async get() {
      this.isLoading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("activos/getDetails", id);
        this.asset = this.$store.getters["activos/activo"];
        this.displayedImages = [...(this.asset.imagenes_adicionales || [])];
        // var planta = localStorage.getItem("plantaSelected");
        //this.notificacion.empresa.id = planta;
        //console.log("USUARIO: ", this.asset.usuario);
        console.log("ASSET: ", this.asset);
        console.log("🔍 INCIDENCIAS DEL ACTIVO (antes de cargar):", this.asset.incidencias);
        
        // Cargar incidencias explícitamente si no vienen en el response
        if (!this.asset.incidencias || this.asset.incidencias.length === 0) {
          await this.loadIncidenciasForActivo(id);
        }
        
        console.log("🔍 INCIDENCIAS DEL ACTIVO (después de cargar):", this.asset.incidencias);
        console.log("🔍 INCIDENCIAS ACTIVAS (computed):", this.incidenciasActivas);

        //console.log("MODELO: ", this.asset.modelo);
        
        // Cargar historial de albaranes
        await this.loadHistorialAlbaranes();
        
        this.isLoading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, algo ha ido mal!! Por favor, refresca la página y vuelve a intentarlo.`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async removeImage() {
      try {
        if (this.editedAsset.modelo.imagen) {
          await this.$store.dispatch(
            "upload/deleteFile",
            this.editedAsset.modelo.imagen.id
          );
          this.editedAsset.modelo.imagen = null;
          this.$notify({
            type: "success",
            message: "Imagen eliminada correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al eliminar la imagen",
        });
        console.error(error);
      }
    },
    getRevisionCemexURL() {
      const numero_serie = this.asset.numero_serie;
      const numero_serie_parseado = numero_serie.replace(/\s/g, "+");
      const idEmpresa = this.asset.empresa.id;

      if (idEmpresa == 74) {
        return (
          "https://misepis-name-images.s3.eu-west-1.amazonaws.com/EQUIPOS_CEMEX/Rev_" +
          numero_serie_parseado +
          ".pdf"
        );
      } else {
        return null;
      }
    },
    downloadFile(revisionId) {
      if (revisionId) {
        window.open(
          `https://misepis-api.delfromsoftware.com/api/revision-download/${revisionId}`,
          "_blank"
        );
      } else {
        const lastRev = this.asset.revisiones.length;
        if (lastRev > 0) {
          const lastRevision = this.asset.revisiones[lastRev - 1];
          window.open(
            `https://misepis-api.delfromsoftware.com/api/revision-download/${lastRevision.id}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "danger",
            message: `El equipo no tiene documento de revisión`,
          });
        }
      }
    },

    downloadAdditionalFile(element) {
      const archivosArray = element.archivos;

      for (let index = 0; index < archivosArray.length; index++) {
        const archivo = archivosArray[index];
        const url_adicional = archivo.url;
        console.log(url_adicional);

        this.downloadFileUrl(url_adicional);
      }
    },

    downloadFileUrl(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$notify({
          type: "danger",
          message: `El documento no está disponible para su descarga.`,
        });
      }
    },
    checkIdRevisor(id) {
      return this.available_usuarios.some(function (gfg) {
        return gfg.id === id;
      });
    },
    async getUsers() {
      this.loading = true; // Activar el loading al inicio del método
      var planta = localStorage.getItem("plantaSelected");
      console.log("PLANTA: ", planta);

      try {
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = profile.id;
        this.notificacion.empresa.id = planta;

        this.$store
          .dispatch("users/fetchEmpleados", {
            idEmpresa: planta,
          })
          .then(() => {
            this.available_usuarios = cloneDeep(
              this.$store.getters["users/empleados"]
            );
            console.log("USUARIOS: ", this.available_usuarios);
          });
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.loading = false; // Desactivar el loading al final del método, siempre
      }
    },
    assign() {
      // Cerrar otros modales antes de abrir el de asignación
      this.showRevisionModal = false;
      this.dialogFormVisibleRev = false;
      this.showIncidenceModal = false;
      this.dialogFormVisible = true;
    },
    revision() {
      // Cerrar otros modales antes de abrir el de solicitar revisión
      this.showRevisionModal = false;
      this.showIncidenceModal = false;
      this.dialogFormVisible = false;
      this.dialogFormVisibleRev = true;
    },
    openRevisionModal(isSemiAutomatic) {
      // Cerrar otros modales antes de abrir el de revisión
      this.dialogFormVisibleRev = false;
      this.showIncidenceModal = false;
      this.dialogFormVisible = false;
      this.isSemiAutomaticRevision = isSemiAutomatic;
      this.showRevisionModal = true;
    },
    closeRevisionModal() {
      this.showRevisionModal = false;
      this.isSemiAutomaticRevision = false;
      // Asegurar que otros modales también estén cerrados
      this.dialogFormVisibleRev = false;
      this.showIncidenceModal = false;
      this.dialogFormVisible = false;
    },
    async onRevisionCreated(revisionData) {
      // Recargar el activo para mostrar la nueva revisión
      await this.get();
      this.$notify({
        type: "success",
        message: "Revisión creada correctamente",
      });
    },

    async assignPost() {
      var el = this.asset;
      el.usuario = this.usuarioSeleccionado;
      this.dialogFormVisible = false;
      await this.$store.dispatch("activos/update", el);
      this.dialogFormVisible = false;

      this.showSwal("success");
      this.$router.go(0);
    },
    async revisionPost() {
      var activo = this.asset;
      let html_activos =
        "<ul><li> Identificador: <b>" +
        activo.nombre +
        "</b>. Número de serie: <b>" +
        activo.numero_serie +
        "</b></li></ul>";

      this.notificacion.activos = html_activos;
      if (activo?.empresa?.id) {
        this.notificacion.empresa.id = activo.empresa.id;
      }
      // this.notificacion.activos = this.multipleSelection;
      console.log("NOTIFICACIÓN:");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "La solicitud se ha enviado correctamente.",
        });
        this.dialogFormVisibleRev = false;
        //this.$router.go(0);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
    async desAssignPost() {
      //this.fullscreenLoading = true;

      var el = this.asset;
      el.usuario = null;
      await this.$store.dispatch("activos/update", el);

      this.dialogFormVisible = false;

      this.showSwal("success_devueltos");
    },

    showSwal(type) {
      if (type === "basic") {
        swal.fire({
          title: `Here's a message!`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
        });
      } else if (type === "info") {
        swal.fire({
          icon: "info",
          title: `Info`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info",
        });
      } else if (type === "success") {
        this.dialogFormVisible = false;
        //this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipo asignado con éxito!`,
            // text: 'Equipos entregados con éxito',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_devueltos") {
        this.isLoading = false;
        swal
          .fire({
            title: `¡Equipo devuelto con éxito!`,
            text: "Este equipo queda disponible para asignarlo a otro usuario.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "warning") {
        swal.fire({
          title: `Warning`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      } else if (type === "question") {
        swal.fire({
          title: `Are you sure?`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question",
        });
      }
    },
    async checkUserRole() {
      try {
        await this.$store.dispatch("profile/me");
        const profile = await this.$store.getters["profile/me"];

        // Verificar si el usuario pertenece a la empresa SALVADOR SEGURIDAD EN ALTURA (ID: 134)
        this.isRevisor = profile.empresas.some((empresa) => empresa.id === 134);

        console.log("Es revisor:", this.isRevisor);
      } catch (error) {
        console.error("Error checking user role:", error);
        this.isRevisor = false;
      }
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        this.editedAsset = { ...this.asset };
        this.displayedImages = [...(this.asset.imagenes_adicionales || [])];
        this.newImages = [];
        this.imagesToDelete = [];
      }
    },
    async saveChanges() {
      try {
        let uploadedImages = [];
        if (this.newImages.length > 0) {
          uploadedImages = await this.uploadAdditionalImages();
        }

        const updateData = {
          id: this.editedAsset.id,
          nombre: this.editedAsset.nombre || "",
          numero_serie: this.editedAsset.numero_serie || "",
          numero_serie_qr: this.editedAsset.numero_serie_qr || "",
          fecha_fabricacion: this.editedAsset.fecha_fabricacion || null,
          fecha_adquisicion: this.editedAsset.fecha_adquisicion || null,
          descripcion: this.editedAsset.descripcion || "",
          ubicacion: this.editedAsset.ubicacion || "",
          modelo: this.editedAsset.modelo || this.asset.modelo,
          usuario: this.editedAsset.usuario || null,
          doc_adicional: this.editedAsset.doc_adicional || [],
          imagenes_adicionales: this.editedAsset.imagenes_adicionales || [],
        };

        if (this.imagesToDelete.length > 0) {
          updateData.imagenes_adicionales =
            updateData.imagenes_adicionales.filter(
              (img) => !this.imagesToDelete.includes(img.id)
            );
        }

        if (uploadedImages.length > 0) {
          updateData.imagenes_adicionales = [
            ...updateData.imagenes_adicionales,
            ...uploadedImages,
          ];
        }

        await this.$store.dispatch("activos/update", updateData);

        this.editMode = false;
        this.newImages = [];
        this.imagesToDelete = [];

        this.$notify({
          type: "success",
          message: "Cambios guardados correctamente",
        });

        if (uploadedImages.length > 0 || this.imagesToDelete.length > 0) {
          this.$router.go(0);
        } else {
          this.asset = {
            ...this.asset,
            ...updateData,
            modelo: this.editedAsset.modelo || this.asset.modelo,
          };
          this.displayedImages = [...(this.asset.imagenes_adicionales || [])];
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al guardar los cambios",
        });
        console.error(error);
      }
    },
    async handleDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      await this.handleImageSelect({ target: { files } });
    },
    async handleImageSelect(event) {
      const files = event.target.files;
      const maxSize = 5 * 1024 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith("image/")) {
          this.$notify({
            type: "warning",
            message: `${file.name} no es una imagen válida.`,
          });
          continue;
        }

        if (file.size > maxSize) {
          this.$notify({
            type: "warning",
            message: `${file.name} es demasiado grande. El tamaño máximo es 5MB.`,
          });
          continue;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.newImages.push(file);
          this.displayedImages.push({
            preview: e.target.result,
            isNew: true,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      }
    },
    removeAdditionalImage(index) {
      const image = this.displayedImages[index];
      if (image.isNew) {
        const fileIndex = this.newImages.findIndex((f) => f === image.file);
        if (fileIndex > -1) {
          this.newImages.splice(fileIndex, 1);
        }
      } else {
        this.imagesToDelete.push(image.id);
      }
      this.displayedImages.splice(index, 1);
    },
    async uploadAdditionalImages() {
      if (this.newImages.length === 0) return [];

      try {
        const formData = new FormData();
        this.newImages.forEach((file) => {
          formData.append("files", file);
        });

        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        const uploadResponse = await axios.post(`${baseUrl}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data && uploadResponse.data.length > 0) {
          if (!this.editedAsset.imagenes_adicionales) {
            this.editedAsset.imagenes_adicionales = [];
          }
          this.editedAsset.imagenes_adicionales.push(...uploadResponse.data);
        }

        return uploadResponse.data || [];
      } catch (error) {
        console.error("Error uploading images:", error);
        throw error;
      }
    },
    openDocumentUpload() {
      this.$refs.documentInput.click();
    },

    async handleDocumentUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      try {
        const formData = new FormData();
        formData.append("files", file);

        // Subir el archivo usando axios directamente con la URL base
        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        const uploadResponse = await axios.post(`${baseUrl}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data && uploadResponse.data.length > 0) {
          // Crear el nuevo documento adicional con la estructura correcta
          const newDoc = {
            nombre: file.name,
            archivos: uploadResponse.data,
          };

          // Inicializar el array si no existe
          if (!this.editedAsset.doc_adicional) {
            this.editedAsset.doc_adicional = [];
          }

          // Añadir el nuevo documento al array
          this.editedAsset.doc_adicional.push(newDoc);

          // Actualizar el activo en el servidor con el nuevo documento
          const updateData = {
            id: this.editedAsset.id,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          await this.$store.dispatch("activos/update", updateData);
          this.asset = {
            ...this.asset,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          this.$notify({
            type: "success",
            message: "Documento subido correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al subir el documento",
        });
        console.error(error);
      }
    },

    async removeDocument(documento) {
      try {
        // Eliminar el documento del array local
        const index = this.editedAsset.doc_adicional.findIndex(
          (doc) => doc.nombre === documento.nombre
        );
        if (index !== -1) {
          // Eliminar los archivos del servidor
          const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
          for (const archivo of documento.archivos) {
            await axios.delete(`${baseUrl}/upload/files/${archivo.id}`);
          }

          // Eliminar el documento del array
          this.editedAsset.doc_adicional.splice(index, 1);

          // Actualizar el activo en el servidor
          const updateData = {
            id: this.editedAsset.id,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          await this.$store.dispatch("activos/update", updateData);
          this.asset = {
            ...this.asset,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          this.$notify({
            type: "success",
            message: "Documento eliminado correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al eliminar el documento",
        });
        console.error(error);
      }
    },
    toggleInspecciones() {
      this.isExpandedInspecciones = !this.isExpandedInspecciones;
    },
    toggleChecklist(inspeccionId) {
      this.$set(this.checklistVisibility, inspeccionId, !this.isChecklistVisible(inspeccionId));
    },
    isChecklistVisible(inspeccionId) {
      return !!this.checklistVisibility[inspeccionId];
    },
    getInspeccionState(inspeccion) {
      switch (inspeccion.estado) {
        case 'completada': return { text: 'Completada', color: '#2dce89', borderColor: '#2dce89' };
        case 'con_incidencia': return { text: 'Con incidencia', color: '#f5365c', borderColor: '#f5365c' };
        case 'pendiente': return { text: 'Pendiente', color: '#fb6340', borderColor: '#fb6340' };
        case 'no_completada': return { text: 'No completada', color: '#11cdef', borderColor: '#11cdef' };
        default: return { text: inspeccion.estado, color: '#888', borderColor: '#888' };
      }
    },
    getDiffDays(date) {
      return this.moment(date).fromNow();
    },
    getMonthName(date) {
      return this.moment(date).format('MMMM');
    },
    formatDate(date) {
      return this.moment(date).format('DD/MM/YYYY');
    },
    formatTime(date) {
      return this.moment(date).format('HH:mm');
    },
    estadoClase(estado) {
      switch (estado) {
        case 'completada':
          return 'success';
        case 'no_completada':
          return 'info';
        case 'pendiente':
          return 'warning';
        default:
          return 'info';
      }
    },
    estadoTexto(estado) {
      switch (estado) {
        case 'completada':
          return 'Completada';
        case 'pendiente':
          return 'Pendiente';
        case 'no_completada':
          return 'No completada';
        default:
          return estado;
      }
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      return this.$moment ? this.$moment(fecha).format('DD/MM/YYYY') : fecha;
    },
    resultadoClase(resultado) {
      switch (resultado) {
        case 'apto':
          return 'apto';
        case 'no_apto':
          return 'no_apto';
        case 'vigilancia':
          return 'vigilancia';
        case 'con_incidencia':
          return 'con_incidencia';
        default:
          return 'apto';
      }
    },
    resultadoTexto(resultado) {
      switch (resultado) {
        case 'apto':
          return 'Apto';
        case 'no_apto':
          return 'No apto';
        case 'vigilancia':
          return 'A vigilar';
        case 'con_incidencia':
          return 'Con incidencia';
        default:
          return resultado;
      }
    },
    formatFechaHora(fecha) {
      if (!fecha) return '';
      return moment(fecha).format('D/M/YYYY [a las] HH:mm:ss');
    },
    tiempoTranscurrido(fecha) {
      if (!fecha) return '';
      const tiempo = moment(fecha).fromNow();
      return tiempo ? `(${tiempo})` : '';
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    getAnswerText(answer) {
      switch (answer) {
        case 0:
          return 'APTO';
        case 1:
          return 'NO APTO';
        case 2:
          return 'A VIGILAR';
        case 3:
          return 'NO APLICA';
        default:
          return 'Desconocido';
      }
    },
    getResultadoColor(resultado) {
      switch (resultado) {
        case 'apto':
          return '#2dce89';
        case 'no_apto':
          return '#f5365c';
        case 'vigilancia':
          return '#fb6340';
        case 'con_incidencia':
          return '#f5365c';
        default:
          return '#11cdef';
      }
    },
    async resolveInspeccion(insp) {
      if (!insp) return;

      this.resolving = true;
      try {
        // 1. PUT para actualizar la inspección con resolución
        const updateData = {
          data: {
            resolucion_tipo: "resuelta",
            resolucion_comentario: this.resolucionComentarios[insp.id],
            estado: "completada",
            resultado: "apto",
            incidencia: false
          }
        };

        await axios.put(
          `${process.env.VUE_APP_API_BASE_URL}/inspeccion-visuals/${insp.id}`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        this.$notify({
          type: "success",
          message: "Observaciones resueltas con éxito.",
        });
        
        // Recargar los datos del activo para mostrar los cambios
        await this.get();
      } catch (error) {
        console.error('Error al resolver inspección:', error);
        this.$notify({
          type: "danger",
          message: "Error al resolver las observaciones: " + (error.response?.data?.error?.message || error.message),
        });
      } finally {
        this.resolving = false;
      }
    },

    // Métodos para gestión de incidencias
    openIncidenceModal() {
      // Cerrar otros modales antes de abrir el de incidencia
      this.showRevisionModal = false;
      this.dialogFormVisibleRev = false;
      this.dialogFormVisible = false;
      this.resetIncidenceData();
      this.showIncidenceModal = true;
    },

    closeIncidenceModal() {
      this.showIncidenceModal = false;
      this.resetIncidenceData();
      // Asegurar que otros modales también estén cerrados
      this.showRevisionModal = false;
      this.dialogFormVisibleRev = false;
      this.dialogFormVisible = false;
    },

    resetIncidenceData() {
      this.incidenceData = {
        tipo: '',
        descripcion: '',
        accion: '',
        prioridad: 'media'
      };
    },

    async submitIncidence() {
      if (!this.isValidIncidence) {
        this.$notify({
          type: "warning",
          message: "Por favor, completa todos los campos requeridos"
        });
        return;
      }

      try {
        this.submittingIncidence = true;

        const apiUrl = process.env.VUE_APP_API_URL || 'https://misepis-api.delfromsoftware.com/api';
        
        // Crear la incidencia del activo
        const incidencePayload = {
          data: {
            tipo: this.incidenceData.tipo,
            descripcion: this.incidenceData.descripcion,
            accion_requerida: this.incidenceData.accion,
            prioridad: this.incidenceData.prioridad,
            estado: 'pendiente',
            activo: this.asset.id,
            usuario_reporta: localStorage.getItem('userId') || null,
            fecha_reporte: new Date().toISOString(),
            observaciones: `INCIDENCIA REPORTADA:
Tipo: ${this.incidenceData.tipo}
Descripción: ${this.incidenceData.descripcion}
Acción requerida: ${this.incidenceData.accion}
Prioridad: ${this.incidenceData.prioridad}
Fecha: ${new Date().toISOString()}
Usuario: ${localStorage.getItem('userName') || 'Usuario'}`
          }
        };

        await axios.post(
          `${apiUrl}/incidencias`,
          incidencePayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        this.$notify({
          type: "success",
          message: "Incidencia reportada correctamente"
        });

        this.closeIncidenceModal();
        
        // Recargar los datos del activo para mostrar la nueva incidencia
        await this.get();

      } catch (error) {
        console.error("Error reportando incidencia:", error);
        this.$notify({
          type: "danger",
          message: "Error al reportar la incidencia: " + (error.response?.data?.error?.message || "Error desconocido")
        });
      } finally {
        this.submittingIncidence = false;
      }
    },

    // Cargar incidencias del activo
    async loadIncidenciasForActivo(activoId) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL || 'https://misepis-api.delfromsoftware.com/api';
        // Filtrar solo incidencias que NO estén resueltas ni cerradas
        const response = await axios.get(`${apiUrl}/incidencias?filters[activo]=${activoId}&filters[$or][0][estado_incidencia][nombre][$ne]=Resuelta&filters[$or][1][estado_incidencia][nombre][$ne]=Cerrada&populate=*`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        console.log('🔍 RESPUESTA API INCIDENCIAS para activo', activoId, ':', response.data);
        const incidencias = response.data.data || [];
        
        // Filtrar también en el frontend por si acaso el filtro del backend no funciona correctamente
        const incidenciasFiltradas = incidencias.filter(inc => {
          const estadoNombre = inc.attributes?.estado_incidencia?.data?.attributes?.nombre ||
                              inc.estado_incidencia?.data?.attributes?.nombre ||
                              inc.estado_incidencia?.nombre ||
                              inc.attributes?.estado_incidencia?.nombre;
          
          if (!estadoNombre) {
            console.warn('⚠️ Incidencia sin estado detectada, excluyendo:', {
              id: inc.id || inc.data?.id,
              descripcion: inc.attributes?.descripcion || inc.descripcion || ''
            });
            return false;
          }
          
          const estadoLower = estadoNombre.toLowerCase();
          const esActiva = estadoLower !== 'resuelta' && estadoLower !== 'cerrada';
          
          if (!esActiva) {
            console.log('🔒 Incidencia resuelta/cerrada excluida:', {
              id: inc.id || inc.data?.id,
              estado: estadoNombre
            });
          }
          
          return esActiva;
        });
        
        // Log detallado de cada incidencia para depuración
        console.log(`📋 Incidencias encontradas para activo ${activoId}:`, incidenciasFiltradas.map(inc => ({
          id: inc.id || inc.data?.id,
          estado: inc.attributes?.estado_incidencia?.data?.attributes?.nombre ||
                 inc.estado_incidencia?.data?.attributes?.nombre ||
                 inc.estado_incidencia?.nombre ||
                 inc.attributes?.estado_incidencia?.nombre || 'sin estado',
          tipo: inc.attributes?.tipo_incidencia?.data?.attributes?.descripcion ||
               inc.tipo_incidencia?.data?.attributes?.descripcion ||
               inc.tipo_incidencia?.descripcion || 'sin tipo',
          descripcion: inc.attributes?.descripcion || inc.descripcion || '',
          createdAt: inc.attributes?.createdAt || inc.createdAt || ''
        })));
        
        // Asignar las incidencias filtradas al activo usando $set para reactividad
        this.$set(this.asset, 'incidencias', incidenciasFiltradas);
        console.log(`✅ Incidencias cargadas para activo ${activoId}: ${incidenciasFiltradas.length} de ${incidencias.length} (filtradas)`);
        return incidenciasFiltradas;
      } catch (error) {
        console.error('Error obteniendo incidencias para activo:', activoId, error);
        // Si hay error, inicializar como array vacío
        this.$set(this.asset, 'incidencias', []);
        return [];
      }
    },

    // Funciones para historial de albaranes (solo albaranes en los que este activo ha estado asignado)
    async loadHistorialAlbaranes() {
      if (!this.asset.id) return;
      
      // Solo cargar historial para empresa Taller Verticales Salvador SEA (idempresa=172)
      if (!this.asset.empresa || this.asset.empresa.id !== 172) {
        this.historialAlbaranes = [];
        return;
      }
      
      try {
        this.loadingHistorial = true;
        const apiUrl = process.env.VUE_APP_API_URL || 'https://misepis-api.delfromsoftware.com/api';

        // Obtener líneas de material (albaran-activo-materials) donde este activo está asignado
        const response = await axios.get(
          `${apiUrl}/albaran-activo-materials?filters[activo][id][$eq]=${this.asset.id}&populate[albaran_activo]=*`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        let materiales = [];
        if (response.data && response.data.data) {
          materiales = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          materiales = response.data;
        }

        // Extraer albarán de cada material (soporta formato API con attributes o anidado .data)
        const getAlbaranFromMaterial = (m) => {
          const rel = m.attributes?.albaran_activo ?? m.albaran_activo;
          if (!rel) return null;
          // Strapi puede devolver { data: { id, attributes: {...} } } o el objeto plano
          if (rel.data && (rel.data.attributes || rel.data.id)) {
            return { id: rel.data.id, ...(rel.data.attributes || {}), ...rel.data };
          }
          if (rel.id && (rel.attributes || rel.fecha_entrega !== undefined)) {
            return { id: rel.id, ...(rel.attributes || {}), ...rel };
          }
          return rel;
        };

        const albaranesMap = new Map();
        materiales.forEach((m) => {
          const albaran = getAlbaranFromMaterial(m);
          if (albaran && albaran.id && !albaranesMap.has(albaran.id)) {
            albaranesMap.set(albaran.id, albaran);
          }
        });

        const list = Array.from(albaranesMap.values());
        const getFechaEntrega = (a) => {
          const d = a.attributes?.fecha_entrega ?? a.fecha_entrega;
          return d ? new Date(d).getTime() : 0;
        };
        this.historialAlbaranes = list.slice().sort((a, b) => getFechaEntrega(b) - getFechaEntrega(a));

        console.log('Historial de albaranes cargado:', this.historialAlbaranes.length, '(solo albaranes con este activo asignado)');
        
      } catch (error) {
        console.error('Error cargando historial de albaranes:', error);
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
        
        this.historialAlbaranes = [];
        
        // Solo mostrar notificación si no es un error 404 (no encontrado)
        if (error.response?.status !== 404) {
          this.$notify({
            type: "warning",
            message: "No se pudo cargar el historial de albaranes: " + (error.response?.data?.error?.message || error.message)
          });
        }
      } finally {
        this.loadingHistorial = false;
      }
    },

    verAlbaran(albaranId) {
      this.$router.push({
        name: "View Albaran",
        params: { id: albaranId }
      });
    },

    formatEstado(estado) {
      return getEstadoTextoUtil(estado);
    },

    getEstadoBadgeClass(estado) {
      return getEstadoBadgeClassUtil(estado);
    },

    getEstadoColor(estado) {
      return getEstadoColorUtil(estado);
    },

    /** Estado del albarán en historial (soporta formato API attributes o plano) */
    getEstadoAlbaranHistorial(albaran) {
      return albaran?.attributes?.estado ?? albaran?.estado ?? null;
    },

    /** Color para badge de estado en historial: mismo criterio que listado albaranes; 'transparent' → gris visible en fondo claro */
    getEstadoColorAlbaranHistorial(estado) {
      const color = getEstadoColorUtil(estado, 'albaran');
      return color === 'transparent' ? '#6c757d' : color;
    },

    toggleHistorial() {
      this.historialExpanded = !this.historialExpanded;
    },
    // Helper para obtener el estado de una incidencia (maneja ambos formatos)
    getEstadoIncidencia(incidencia) {
      return incidencia.estado_incidencia?.nombre || 
             incidencia.estado_incidencia?.data?.attributes?.nombre ||
             incidencia.attributes?.estado_incidencia?.data?.attributes?.nombre || 
             'Sin estado';
    },
    // Helper para obtener otros campos de incidencia
    getIncidenciaField(incidencia, field) {
      return incidencia[field] || 
             incidencia.attributes?.[field] ||
             incidencia.data?.attributes?.[field] ||
             '';
    }
  },
  computed: {
    isSalvadorSeguridad() {
      return this.asset.empresa && (Number(this.asset.empresa.id) === 134 || Number(this.asset.empresa.id) === 15);
    },
    inspeccionesVisualesSorted() {
      if (!this.asset.inspeccion_visuals) return [];
      return [...this.asset.inspeccion_visuals]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map(insp => ({
          ...insp,
          showChecklist: false // Inicializamos showChecklist para cada inspección
        }));
    },
    isPendingInspection() {
      return this.inspeccionesVisualesSorted.some(i => i.estado === 'pendiente');
    },
    isValidIncidence() {
      return this.incidenceData.tipo && 
             this.incidenceData.descripcion && 
             this.incidenceData.accion && 
             this.incidenceData.prioridad;
    },
    // Computed para filtrar solo las incidencias activas (no resueltas ni cerradas)
    incidenciasActivas() {
      if (!this.asset.incidencias || !Array.isArray(this.asset.incidencias)) {
        return [];
      }
      
      const activas = this.asset.incidencias.filter(incidencia => {
        // Manejar tanto formato deserializado como Strapi v4
        const estadoNombre = incidencia.estado_incidencia?.nombre || 
                            incidencia.estado_incidencia?.data?.attributes?.nombre ||
                            incidencia.attributes?.estado_incidencia?.data?.attributes?.nombre;
        
        if (!estadoNombre) {
          // Si no tiene estado definido, NO asumir que está activa (más conservador)
          console.warn('⚠️ Incidencia sin estado detectada:', {
            id: incidencia.id || incidencia.data?.id,
            descripcion: incidencia.attributes?.descripcion || incidencia.descripcion || 'sin descripción'
          });
          return false; // Cambiado: no mostrar incidencias sin estado
        }
        
        // Solo considerar activas las incidencias que NO estén resueltas ni cerradas
        const estadoLower = estadoNombre.toLowerCase();
        const esActiva = estadoLower !== 'resuelta' && estadoLower !== 'cerrada';
        
        if (esActiva) {
          console.log('✅ Incidencia activa detectada:', {
            id: incidencia.id || incidencia.data?.id,
            estado: estadoNombre,
            tipo: incidencia.attributes?.tipo_incidencia?.data?.attributes?.descripcion ||
                 incidencia.tipo_incidencia?.data?.attributes?.descripcion ||
                 incidencia.tipo_incidencia?.descripcion || 'sin tipo'
          });
        }
        
        return esActiva;
      });
      
      console.log(`🔍 Incidencias activas filtradas para activo ${this.asset.id}: ${activas.length} de ${this.asset.incidencias.length}`);
      return activas;
    },
    // Computed para todas las incidencias ordenadas por fecha (más recientes primero)
    historialIncidencias() {
      if (!this.asset.incidencias || !Array.isArray(this.asset.incidencias)) {
        return [];
      }
      
      // Ordenar por fecha de creación (más recientes primero)
      return [...this.asset.incidencias].sort((a, b) => {
        const dateA = new Date(a.createdAt || a.attributes?.createdAt || 0);
        const dateB = new Date(b.createdAt || b.attributes?.createdAt || 0);
        return dateB - dateA;
      });
    }
  }
};
</script>
<style scoped>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}

.dropzone {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.dropzone-active {
  border-color: #5e72e4;
  background: #eef1fe;
}

.dropzone-content {
  color: #666;
}

.dropzone-content i {
  color: #5e72e4;
}

.dropzone-content p {
  margin: 10px 0;
}

/* Asegurar que el SweetAlert2 siempre esté por encima */
.swal2-container {
  z-index: 2100 !important;
}

/* Ajustar el z-index del diálogo de Element UI */
.el-dialog__wrapper {
  z-index: 2000;
}

.qr-code {
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
  background: white;
}

.text-sm {
  font-size: 0.875rem;
}

.inspeccion-visual-block {
  border-radius: 12px;
  border: 2px solid #e9ecef;
  background: #f8f9fa;
  transition: border-color 0.2s;
}
.inspeccion-visual-block.success {
  border-color: #2dce89;
}
.inspeccion-visual-block.danger {
  border-color: #f5365c;
}
.inspeccion-visual-block.warning {
  border-color: #fb6340;
}
.inspeccion-visual-block.info {
  border-color: #11cdef;
}
.badge-estado {
  font-size: 1em;
  font-weight: 600;
  padding: 0.5em 1em;
  border-radius: 8px;
  color: #fff;
}
.badge-estado.success {
  background: #2dce89;
}
.badge-estado.danger {
  background: #f5365c;
}
.badge-estado.warning {
  background: #fb6340;
}
.badge-estado.info {
  background: #11cdef;
}
.img-inspeccion {
  max-width: 80px;
  max-height: 80px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  object-fit: cover;
}
.badge-resultado {
  font-size: 1em;
  font-weight: 600;
  padding: 0.5em 1em;
  border-radius: 8px;
  color: #fff;
}
.badge-resultado.apto {
  background: #2dce89;
}
.badge-resultado.no_apto {
  background: #f5365c;
}
.badge-resultado.vigilancia {
  background: #fb6340;
}
.badge-apto-uso {
  color: #fff;
  background-color: green;
  font-size: 1em;
  font-weight: 600;
  padding: 0.5em 1em;
  border-radius: 8px;
}

.subcard {
  border-bottom: 1px solid #eee;
  background: white;
}

.subcard:last-child {
  border-bottom: none;
}

h6 {
  margin: 0;
  font-size: 0.875rem;
}

/* Checklist Styles */
.checklist-container {
  background: #f8f9fa;
  border-radius: 8px;
}

.checklist-item {
  padding: 0 1rem;
}

.checklist-item:last-child {
  border-bottom: none !important;
}

.question-number {
  font-weight: 600;
  color: #32325d;
  min-width: 25px;
}

.question-text {
  white-space: pre-line;
  color: #525f7f;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef;
}
</style>
